import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button, Box } from '@mui/material';
import { BusinessService } from '../../services/api';
import { useNavigate } from 'react-router-dom';

const UserCampaignsPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await BusinessService.getCampaigns();
        setCampaigns(response.data);
      } catch (err: any) {
        setError(err?.response?.data?.error || 'Failed to fetch campaigns');
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, []);

  const handleUpdate = (campaignId: number) => {
    navigate(`/campaign-creator?campaignId=${campaignId}`);
  };

  const handleDelete = async (campaignId: number) => {
    if (!window.confirm('Are you sure you want to delete this campaign?')) return;

    try {
      await BusinessService.deleteCampaign(campaignId);
      setCampaigns((prev) => prev.filter((campaign) => campaign.id !== campaignId));
      setSuccessMessage('Campaign deleted successfully');
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Failed to delete campaign');
    }
  };

  if (loading) {
    return <Typography>Loading campaigns...</Typography>;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Your Campaigns
        </Typography>

        {successMessage && (
          <Typography color="success.main" sx={{ mb: 2 }}>
            {successMessage}
          </Typography>
        )}

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Brand</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {campaigns.map((campaign) => (
              <TableRow key={campaign.id}>
                <TableCell>{campaign.title}</TableCell>
                <TableCell>{campaign.brand}</TableCell>
                <TableCell>{campaign.value}</TableCell>
                <TableCell>{campaign.description || 'N/A'}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleUpdate(campaign.id)}
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleDelete(campaign.id)}
                    >
                      Delete
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default UserCampaignsPage;